import Head from "next/head";
import React from "react";

import WordpressApi, { Menus } from "../../services/wordpressApi";
import Home from "../";

export default Home;

export async function getServerSideProps({ pathname }: any) {
  let data: any;
  let menus = {};
  let header = "";

  try {
    [data, menus] = await Promise.all([
      WordpressApi.getPage("home-page", "en"),
      WordpressApi.getMenus("en"),
    ]);
  } catch (e) {
    console.log(e);
  }

  return {
    props: {
      data: data.blocks,
      tags: data.tags,
      header: header,
      htmlHead: data?.htmlHead,
      menus,
      lang: "en",
    },
  };
}
